/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, Input, OnChanges, SimpleChanges} from '@angular/core';
import {safeDetectChanges} from '../common/util/safe-detect-changes';
import template from './advertiser-analysis-page.component.html';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';

type AdvertiserAnalysisTab = 'charts' | 'reports' | 'traffic' | 'location';

@Component({
  standalone: false,
  selector: 'adn-advertiser-analysis-page',
  template
})
export class AdvertiserAnalysisPageComponent implements OnChanges {
  @Input() model: any;
  private _modelCommsDirect: any;
  private _isNewDirect: boolean | undefined;

  @Input()
  set modelComms(value: any) {
    this._modelCommsDirect = value;
  }

  get modelComms(): any {
    return this._modelCommsDirect;
  }

  @Input()
  set isNew(value: boolean) {
    this._isNewDirect = value;
  }

  get isNew(): boolean {
    return this._isNewDirect;
  }

  effectiveIsNew = false;
  activeTab: AdvertiserAnalysisTab = 'charts';
  reportsLoaded = false;
  trafficLoaded = false;
  locationLoaded = false;
  canSeeReports = false;

  private subscribedModelComms: any;

  constructor(
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.canSeeReports = LocalUserPermissions.getAnyVisibility().RUN_REPORTS === true
      || LocalUserPermissions.getAnyVisibility().AX_ADVERTISER;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isNew) {
      this.effectiveIsNew = !!this.isNew;
    }
    if (changes.modelComms) {
      this.subscribeModelComms();
    }
  }

  selectTab(tab: AdvertiserAnalysisTab): void {
    this.activeTab = tab;
    if (tab === 'reports') {
      this.reportsLoaded = true;
    } else if (tab === 'traffic') {
      this.trafficLoaded = true;
    } else if (tab === 'location') {
      this.locationLoaded = true;
    }
  }

  private subscribeModelComms(): void {
    if (!this.modelComms || this.subscribedModelComms === this.modelComms) {
      return;
    }
    this.subscribedModelComms = this.modelComms;
    this.modelComms.addSubscriber((data: any, type: any, isNewFromComms: boolean) => {
      if (type) {
        return;
      }
      if (isNewFromComms === true || isNewFromComms === false) {
        this.effectiveIsNew = isNewFromComms;
      } else if (data?.name) {
        this.effectiveIsNew = false;
      }
      safeDetectChanges(this.cdr);
    });
  }
}
